import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import type { GridPaginationModel } from "@mui/x-data-grid";
import { LojaDataGrid } from "../../common";
import type { IPedidoGerenciarListItem } from "interfaces/loja";
import { createPedidosColumns } from "./pedidosColumns";

type PedidosOrdersGridProps = {
  rows: IPedidoGerenciarListItem[];
  total: number;
  page: number;
  pageSize: number;
  loading: boolean;
  onPaginationModelChange: (model: GridPaginationModel) => void;
};

export default function PedidosOrdersGrid({
  rows,
  total,
  page,
  pageSize,
  loading,
  onPaginationModelChange,
}: PedidosOrdersGridProps) {
  const navigate = useNavigate();

  const columns = useMemo(() => createPedidosColumns(navigate), [navigate]);

  return (
    <LojaDataGrid
      rows={rows}
      getRowId={(r) => r.id}
      columns={columns}
      loading={loading}
      checkboxSelection
      paginationMode="server"
      rowCount={total}
      pageSizeOptions={[10, 20, 25, 50, 100]}
      paginationModel={{ page: page - 1, pageSize }}
      onPaginationModelChange={onPaginationModelChange}
      onRowClick={(params) => navigate(`/loja/pedidos/${params.row.id}`)}
      sx={{
        border: "1px solid",
        borderColor: "grey.200",
        borderRadius: 2,
        "& .MuiDataGrid-row": {
          cursor: "pointer",
        },
        "& .MuiDataGrid-row:hover": {
          bgcolor: "rgba(249, 96, 48, 0.04)",
        },
        "& .MuiDataGrid-columnHeaders": {
          bgcolor: "grey.100",
          fontWeight: 700,
        },
      }}
    />
  );
}
